(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Comune', Comune);

    Comune.$inject = ['$resource'];

    function Comune ($resource) {
        var resourceUrl =  'api/comunes/:id?size=2000&sort=comune,asc';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
